import { GOOGLE_CONFIG as IOS_GOOGLE_CONFIG } from '../config/ios';
import { GOOGLE_CONFIG as ANDROID_GOOGLE_CONFIG } from '../config/android';
import { getGoogleConfig } from '../config/web';
import { isWeb, isIOS } from '../platform/platform';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { configureApiBaseUrl } from '../config/api';

export const exchangeCodeForTokens = async (code: string, codeVerifier: string) => {
  let config;
  if (isWeb()) {
    config = getGoogleConfig();
  } else {
    if (isIOS()) {
      config = IOS_GOOGLE_CONFIG;
    } else {
      config = ANDROID_GOOGLE_CONFIG;
    }
  }

  const clientID = config.CLIENT_ID;
  const redirectURI = config.REDIRECT_URI;

  console.log("client ID: ", clientID);
  console.log("redirect URI: ", redirectURI);
  console.log("Token exchange payload", {
    code,
    client_id: clientID,
    redirectURI,
    grant_type: "authorization_code",
    codeVerifier,
  });

  const response = await fetch('https://oauth2.googleapis.com/token', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({
      code,
      client_id: clientID,        // Web or Mobile Client ID
      redirect_uri: redirectURI,  // Custom URI
      grant_type: 'authorization_code',
      code_verifier: codeVerifier,
    }).toString(),
  });

  const tokens = await response.json();
  if (!response.ok) {
    console.log("exchange failed");
    console.log("Response body:", JSON.stringify(tokens, null, 2));
    throw new Error(tokens.error || 'Failed to exchange tokens');
  }
  const { access_token, refresh_token, id_token, expires_in } = tokens;

  // Return the individual tokens as an object
  return {
    accessToken: access_token,
    refreshToken: refresh_token,
    idToken: id_token,
    expiresIn: expires_in, // Token expiry time in seconds
  };
};

export const exchangeFirebaseTokenForAccessTokens = async (
  idToken: string
): Promise<boolean> => {
  const API_BASE_URL = await configureApiBaseUrl();

  console.log('[exchangeFirebaseTokenForAccessTokens] Posting to:', `${API_BASE_URL}/api/auth/firebase/session`);
  console.log('Using ID token:', idToken);

  const response = await fetch(`${API_BASE_URL}/api/auth/firebase/session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
  });

  console.log('Response from firebase/session:', response.status, await response.clone().json());

  if (!response.ok) {
    console.error('Firebase token exchange failed');
    return false;
  }

  const { access_token, refresh_token } = await response.json();

  if (access_token) {
    await SecureStoragePlugin.set({ key: 'access_token', value: access_token });
  }
  if (refresh_token) {
    await SecureStoragePlugin.set({ key: 'refresh_token', value: refresh_token });
  }

  return true;
};
